import type { NotifyPort } from '@/features/messages/domain/notify'
import type { Member, WorkflowPort } from '../domain/workflow'

// Loads every member across teams. Used to resolve an assignee's user ID to a
// display name on the board, where work items span multiple teams.
const listAllMembers = async (port: WorkflowPort, notify: NotifyPort): Promise<Member[]> => {
	try {
		return await port.listAllMembers()
	} catch {
		notify.error('workflow.membersLoadFailed')
		return []
	}
}

export { listAllMembers }
